import { atom } from 'jotai';

/**
 * Refcount of mounted {@link SessionWorkVoiceSidebarSync} instances. Placement
 * uses `count > 0` so Voice only takes `session-rhs` when Evidence can host
 * Work/Voice (Ask Heidi + Work-in-session + session). Without this, placement
 * stays `session-rhs` while Sync is gated off and overlay is suppressed —
 * Voice vanishes.
 */
export const voiceSessionRhsHostCountAtom = atom(0);
